import { formatMoney } from '@/utils/format-money';

export const CONTAINER_TYPE_VALUE_MAX_DOLLARS = 999999;

export type ContainerTypeValueInput =
  | { cents: number | null; error?: undefined }
  | { cents?: undefined; error: string };

/** Whole dollars only for now (ENG-3033); the engine stores cents. */
export function parseContainerTypeValue(
  input: string,
): ContainerTypeValueInput {
  const trimmed = input.trim();
  if (trimmed === '') return { cents: null };

  const amount = trimmed.replace(/^\$\s*/, '');
  if (!/^(\d+|\d{1,3}(,\d{3})+)$/.test(amount)) {
    return { error: 'Enter a whole dollar amount, e.g. 1,250' };
  }

  const dollars = Number(amount.replace(/,/g, ''));
  if (dollars > CONTAINER_TYPE_VALUE_MAX_DOLLARS) {
    return { error: 'The value can be at most $999,999' };
  }

  return { cents: dollars * 100 };
}

export function formatContainerTypeValue(
  cents: number | null | undefined,
): string {
  if (cents === null || cents === undefined) return '';
  return `$${formatMoney(cents, false, 0)}`;
}

export function containerTypeValueInput(
  cents: number | null | undefined,
): string {
  if (cents === null || cents === undefined) return '';
  return formatMoney(cents, false, 0);
}
